/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFlag2 = createReactComponent("outline", "flag-2", "IconFlag2", [["path", { "d": "M5 14h14v-9h-14v16", "key": "svg-0" }]]);

export { IconFlag2 as default };
//# sourceMappingURL=IconFlag2.mjs.map
